import {
  SET_GROUP_ORDER_PAGE,
  CLEAR_GROUP_ORDER_PAGE,
  SET_CLIENT_SETTINGS,
} from '@actions/groupOrderPage'

const initialGroupOrderPageState = {
  account: undefined,
  id: undefined,
  date: undefined,
}
const initialClientSettingsState = []

export function groupOrderPage(state = initialGroupOrderPageState, action) {
  const { type, groupOrderPage } = action

  switch (type) {
    case SET_GROUP_ORDER_PAGE:
      return { ...groupOrderPage }
    case CLEAR_GROUP_ORDER_PAGE:
      return { ...initialGroupOrderPageState }
    default:
      return state
  }
}

export function clientSettings(state = initialClientSettingsState, action) {
  const { type, clientSettings } = action

  switch (type) {
    case SET_CLIENT_SETTINGS:
      return [...clientSettings]
    default:
      return state
  }
}
